import PageShell from "../components/PageShell";
import company from "../data/company.json";
import copy from "../lib/catalog/copy-strings.json";

export default function TermsPage() {
        const c = copy.terms;
        const s = [
                { n: 1, title: "Acceptance", body: c.s1 },
                { n: 2, title: "Eligibility", body: c.s2 },
                { n: 3, title: "Account & orders", body: c.s3 },
                { n: 4, title: "Pricing & taxes", body: c.s4, testid: "terms-s4-carveout" },
                { n: 5, title: "Payment & refunds", body: c.s5 },
                { n: 6, title: "Shipping", body: c.s6 },
                { n: 7, title: "Warranty & returns", body: c.s7 },
                { n: 8, title: "Limitation of liability", body: c.s8 },
                { n: 9, title: "User conduct", body: c.s9 },
                { n: 10, title: "Intellectual property", body: c.s10 },
                { n: 11, title: "Dispute resolution", body: c.s11.replace("{email}", company.support_email) },
                { n: 12, title: "Governing law", body: c.s12 },
                { n: 13, title: "Severability", body: c.s13 },
                { n: 14, title: "Contact", body: "See our Contact page." },
                { n: 15, title: "Business & legal identity", body: c.s15, testid: "terms-s15-business-identity" },
        ];
        return (
                <PageShell title={c.title} path="/terms">
                        <p className="font-mono text-[11px] tracking-[0.18em] uppercase text-[#F59E0B]">{c.eyebrow}</p>
                        <h1 className="mt-3 font-display uppercase leading-[0.95] text-[38px] md:text-[48px] lg:text-[64px]">
                                <span className="text-white">{c.heading_lead}</span>
                                <span className="text-[#F59E0B]">{c.heading_accent}</span>
                        </h1>
                        <div className="mt-10 space-y-10 max-w-[76ch] text-white/80 leading-relaxed">
                                {s.map((sec) => (
                                        <section key={sec.n} data-testid={sec.testid}>
                                                <h2 className="text-[#F59E0B] font-mono text-[13px] tracking-[0.16em] uppercase">§{sec.n} · {sec.title}</h2>
                                                {Array.isArray(sec.body) ? (
                                                        <ul className="mt-3 list-disc pl-5 space-y-1">
                                                                {sec.body.map((b, i) => <li key={i}>{b}</li>)}
                                                        </ul>
                                                ) : (
                                                        <p className="mt-3">{sec.body}</p>
                                                )}
                                        </section>
                                ))}
                        </div>
                </PageShell>
        );
}
